import React, { useState, useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import CvSectionIntro from "../cvSections/profile/Intro";
import CvSection from "../cvSections/CvSection";
import Hoc from "../../util/Hoc";
import locationParser from "../../util/locationParser";

import "./body.css";

const Body = (props) => {
  const [selectedElement, setSelectedElement] = useState("");
  // console.log(props.cvParts);

  let cvParts = props.cvParts.map((part) => {
    let partTitle = Object.keys(part)[0];
    let cvPartSections = Object.values(part)[0].map((section) => {
      if (section.id === "introduction") {
        return <CvSectionIntro key={section.id} id="introduction" />;
      } else {
        return <CvSection key={section.id} title={section.title} id={section.id} />;
      }
    });
    return <Route key={partTitle} path={"/" + partTitle} exact render={(routeProps) => <Hoc>{cvPartSections}</Hoc>} />;
  });

  let defaultPath = "/profile";// /profile
  let pathHash = locationParser(window.location).hash;
  if (pathHash.length !== 0 && selectedElement !== pathHash) {
  setSelectedElement(pathHash);
  }
  let pathSearch = locationParser(window.location).search;
  /* if the entered path in the addressbar is not refering to the main react index file, 
  in error404.html file (in public folder) it will be redirected and the entered path name 
  will be stored as a search factor (enteredPath) which here we can capture.
  this just happen when site is up and accessed from server not in local mode
  */
  if (pathSearch.length > 0) {
    pathSearch = pathSearch.find((item) => item[0] === "enteredPath");
    if (pathSearch) {
      defaultPath = pathSearch[1];
    }
  }

  useEffect(() => {
    if (document.getElementById(selectedElement)) {
      document.getElementById(selectedElement).scrollIntoView();
    }
  });

  return (
    <main className="Main">
      <Switch>
        {cvParts}
        <Redirect to={defaultPath} />
      </Switch>
    </main>
  );
};

export default Body;

// return (
//   <main className="Main">
//     <Switch>
//       <Route
//         path="/profile"
//         exact
//         render={(routeProps) => (
//           <Hoc>
//             <CvSectionIntro id="introduction" />
//             <CvSection title={"EDUCATION"} id="section-education" />
//           </Hoc>
//         )}
//       />
//       <Route
//         path="/professional"
//         exact
//         render={(routeProps) => (
//           <Hoc>
//             <CvSection title={"CAREER RESUME"} id="section-pro-career-resume" />
//             <CvSection title={"EMPLOYMENT EXPERIENCE"} id="section-pro-employment-exp" />
//             <CvSection title={"INDEPENDENT EXPERIENCE"} id="section-pro-ind-exp" />
//           </Hoc>
//         )}
//       />
//       <Route
//         path="/non-professional"
//         exact
//         render={(routeProps) => (
//           <Hoc>
//             <div></div>
//             <CvSection title={"WEB DEVELOPMENT"} id="section-nonpro-web" />
//             <CvSection title={"COLLABORATIONS"} id="section-nonpro-collaborations" />
//           </Hoc>
//         )}
//       />
//       <Route
//         path="/skills"
//         exact
//         render={(routeProps) => (
//           <Hoc>
//             <CvSection title={"TRAININGS"} id="section-skills-trainings" />
//             <CvSection title={"LANGUAGE"} id="section-skills-language" />
//             <CvSection title={"SOFTWARE"} id="section-skills-software" />
//             {/* <CvSection title={"SKILLS"} id="section-skills" /> */}
//           </Hoc>
//         )}
//       />
//       <Redirect to="/profile" />
//     </Switch>
//   </main>
// );
